import { cn } from "@wags/ui/ui-utils";
import type { CSSProperties } from "react";

export function SpriteLoop({
    src,
    frames,
    aspectRatio,
    duration,
    role,
    label,
    shadow = false,
    animate = true,
    className,
    style,
}: {
    src: string;
    frames: number;

    aspectRatio: string;

    duration: string;

    role: "status" | "img";
    label: string;

    shadow?: boolean;

    animate?: boolean;
    className?: string;
    style?: CSSProperties;
}) {
    const inner = (
        <>
            {shadow && (
                <span
                    aria-hidden="true"
                    className="sprite-loop-shadow"
                    style={{ animationDuration: duration }}
                />
            )}
            <span aria-hidden="true" className="sprite-loop-frame">
                <span
                    aria-hidden="true"
                    className="sprite-loop-strip"
                    style={{
                        width: `${frames * 100}%`,
                        backgroundImage: `url("${src}")`,
                        animationDuration: duration,
                        animationTimingFunction: `steps(${frames}, end)`,
                        animationPlayState: animate ? undefined : "paused",
                    }}
                />
            </span>
        </>
    );
    const boxClass = cn("sprite-loop", className);
    const boxStyle = { aspectRatio, ...style };

    return role === "status" ? (
        <output aria-label={label} className={boxClass} style={boxStyle}>
            {inner}
        </output>
    ) : (
        <span
            role="img"
            aria-label={label}
            className={boxClass}
            style={boxStyle}
        >
            {inner}
        </span>
    );
}
